<template>
  <main id="main">
    <header class="header_page shadow_box slideInDown">
        <p id="title_header_page" class="bold">{{ t('add_post') }}</p>
        <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </header>

    <div class="content-wrapper p-3 d-flex flex-column align-items-center row-gap-3 w-100">
        <h2 class="font_larger bold w-100">
            {{ t('upload_image') }}
        </h2>

        <div 
            class="w-100 bg-white rounded-5 shadow d-flex justify-content-center align-items-center overflow-hidden cursor-pointer position-relative" 
            style="height: 350px"
            @click="triggerUpload"
        >
            <div v-if="isUploading" class="spinner-border text-primary" role="status">
                <span class="visually-hidden">...</span>
            </div>
            <img v-else-if="imagePreview" :src="imagePreview" class="w-100 h-100 object-fit-contain">
            <div v-else class="d-flex flex-column align-items-center">
                <img src="@/assets/imgs/add-post.svg" alt="" class="icon-size-6 p-3">
                <p class="text_color_gray">{{ t('click_to_select') }}</p>
            </div>
            
            <input type="file" ref="fileInput" @change="onFileSelected" accept="image/*" style="display: none">
        </div>

        <h2 class="font_larger bold w-100 mt-3">
            {{ t('insert_desc') }}
        </h2>

        <div class="w-100 bg-white rounded-5 shadow d-flex justify-content-center align-items-center p-3">
            <textarea 
                v-model="caption" 
                class="w-100 border-0 outline-none" 
                rows="6" 
                :placeholder="t('write_desc')"
            ></textarea>
        </div>

        <button class="button mt-3" @click="submitPost" :disabled="submitting || isUploading">
            {{ submitting ? t('loading') : t('submit_post') }}
        </button>

       
        <div class="scroll-spacer"></div>
    </div>
    
    <TeacherBottomNav />
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import TeacherBottomNav from '@/components/TeacherBottomNav.vue'

export default {
  name: 'TeacherAddPost',
  components: {
    TeacherBottomNav
  },
  data() {
    return {
        caption: '',
        imagePreview: null,
        uploadedFileName: '',
        isUploading: false,
        submitting: false
    }
  },
  methods: {
    triggerUpload() {
        if (!this.isUploading) {
            this.$refs.fileInput.click();
        }
    },
    async onFileSelected(event) {
        const file = event.target.files[0];
        if (file) {
            this.isUploading = true;
            
            const reader = new FileReader();
            reader.onload = e => { this.imagePreview = e.target.result; };
            reader.readAsDataURL(file);

            const formData = new FormData();
            formData.append('pic', file);
            formData.append('apikey', '4f3d2a9b7c1e5d6f8a0b9c3d2e4f6a7b');

            try {
                const res = await apiClient.post('/upload_pic', formData);
                if (res.data.status === 'ok') {
                    this.uploadedFileName = res.data.pic_name;
                } else {
                    this.notify(this.t('upload_error'), 'error');
                    this.imagePreview = null;
                }
            } catch (e) {
                console.error(e);
                this.notify(this.t('connection_error'), 'error');
                this.imagePreview = null;
            } finally {
                this.isUploading = false;
            }
        }
    },
    async submitPost() {
        if (!this.uploadedFileName) {
            this.notify(this.t('upload_image'), 'error');
            return;
        }
        if (!this.caption.trim()) {
            this.notify(this.t('write_desc'), 'error');
            return;
        }

        this.submitting = true;
        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId,
                pic: this.uploadedFileName,
                caption: this.caption
            });

            const response = await apiClient.post('/teacher/add_post', formData);

            if (response.data.status === 'ok') {
                this.notify(response.data.message || this.t('successful_submit'), 'success');
                this.$router.push({ name: 'TeacherMyProfile' });
            } else {
                this.notify(response.data.message || this.t('error_submit'), 'error');
            }
        } catch (error) {
            console.error(error);
            this.notify(this.t('connection_error'), 'error');
        } finally {
            this.submitting = false;
        }
    }
  }
}
</script>

<style scoped>
.content-wrapper {
    min-height: 1vh; 
    padding-bottom: 120px; 
}

.scroll-spacer {
    height: 50px; 
}

.cursor-pointer {
    cursor: pointer;
}

.object-fit-contain {
    object-fit: contain;
}

.outline-none {
    outline: none;
}

.text_color_gray {
    color: #a0a0a0;
}
</style>